import { ReactElement } from 'react';
import { Button, ModalWindow } from 'components';
import { useTranslation } from 'react-i18next';
import { SmallWarningIcon } from '~/icons/WarningIcon';
import { ButtonContainer, ConfirmationContainer } from './styles';

interface DeletionConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: 'schedule' | 'exception';
}

export function DeletionConfirmationModal({
  onConfirm,
  onClose,
  open,
  type,
}: Readonly<DeletionConfirmationModalProps>): ReactElement | null {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <ModalWindow
      style={{ padding: '0', overflowX: 'hidden', width: '500px' }}
      borderTop
      onClickOutside={onClose}
    >
      <ConfirmationContainer>
        <div>
          <div style={{ display: 'flex', gap: 10 }}>
            <SmallWarningIcon />
            <h4 style={{ fontWeight: 'bold', marginLeft: '10px' }}>
              {t(type === 'schedule' ? 'certezaDeletarProgramacao' : 'certezaDeletarExcecao')}
            </h4>
          </div>
          <ButtonContainer>
            <Button
              style={{ width: '200px' }}
              variant="primary"
              onClick={onConfirm}
            >
              {t('prosseguir')}
            </Button>
            <Button
              style={{ width: '200px' }}
              onClick={onClose}
              variant="secondary"
            >
              {t('cancelar')}
            </Button>
          </ButtonContainer>
        </div>
      </ConfirmationContainer>
    </ModalWindow>
  );
}
